<ngx-one-column-layout (showBearerCopied)="handleCopyBearer($event)">
  <nb-menu [items]="menu"></nb-menu>
  <router-outlet></router-outlet>
</ngx-one-column-layout>

@if (showBearerCopied) {
  <div class="floating-xen-tag">
    <div class="xen-tag xen-tag--large xen-tag--success tag-styles">
      <i class="fa-regular fa-copy xen-tag__icon xen-tag__icon--left ms-0 me-2"></i>
      Bearer token copied
    </div>
  </div>
}
<tgx-toasts></tgx-toasts>
